import { type InstalledPlugins } from '../index'
import { type TMInstanceWithPlugins, type TmPlugin } from '../types'

export interface BusinessDayTmMethods {
  isBusinessDay(day: number, isPayrollBusinessDay?: boolean): boolean
  businessDaysAdd(days: number, isPayrollBusinessDay?: boolean): TMInstanceWithPlugins<InstalledPlugins>
  businessDaysSubtract(days: number, isPayrollBusinessDay?: boolean): TMInstanceWithPlugins<InstalledPlugins>
  dayOfWeek(): number
}

export const businessDayTMPlugin: TmPlugin<BusinessDayTmMethods> = instance => {
  const proto = instance.prototype

  proto.isBusinessDay = function (day, isPayrollBusinessDay = false) {
    const workingWeekdays = isPayrollBusinessDay ? [1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 5]

    return workingWeekdays.includes(day)
  }

  proto.dayOfWeek = function () {
    return this['$dateEngine'].day()
  }

  proto.businessDaysAdd = function (days: number, isPayrollBusinessDay = false) {
    const numericDirection = days < 0 ? -1 : 1
    let daysRemaining = Math.abs(days)
    let currentDay = this.clone()

    while (daysRemaining > 0) {
      currentDay = currentDay.add(numericDirection, 'd')
      if (this.isBusinessDay((currentDay as unknown as BusinessDayTmMethods).dayOfWeek(), isPayrollBusinessDay))
        daysRemaining -= 1
    }

    return currentDay as TMInstanceWithPlugins<InstalledPlugins>
  }

  proto.businessDaysSubtract = function (days: number, isPayrollBusinessDay = false) {
    return this.businessDaysAdd(days * -1, isPayrollBusinessDay)
  }
}
